import request from '@/utils/request.js';

const addToken = {
  _KEY: 'v_token_map',
  keyPrefix: 'vToken'
}

// 获取活动全局配置信息
export const fetchActInfo = (id) => {
  return request({
    url: `/v1/voucher/act_info/${id}`,
    method: 'get',
    addToken,
  });
}
// 获取用户信息
export const fetchUserInfo = (id) => {
  return request({
    url: `/v1/voucher/user_info/${id}`,
    method: 'get',
    addToken,
  });
}

// 游戏会场配置
export const fetchGameList = (id) => {
  return request({
    url: `/v1/voucher/game_list_more/${id}`,
    method: 'get',
    addToken,
  });
}

// 福利列表
export const fetchWelfareList = (id, params) => {
  return request({
    url: `/v1/voucher/game_welfare_list/${id}`,
    method: 'get',
    addToken,
    params,
  });
}

// 领取
export const onReceiveApi = (id, data) => {
  return request({
    url: `/v1/voucher/get_welfare/${id}`,
    method: 'post',
    addToken,
    data,
  });
}

// 领取付费奖励
export const onReceivePayApi = (id, data) => {
  return request({
    url: `/v1/voucher/get_welfare_check/${id}`,
    method: 'post',
    addToken,
    data,
  });
}

// 记录
export const fetchRecord = (id, params) => {
  return request({
    url: `/v1/voucher/welfare_user_receive/${id}`,
    method: 'get',
    addToken,
    params,
  });
}

// 埋点
export const reportData = (id, data) => {
  return request({
    url: `/v1/voucher/report_data/${id}`,
    method: 'post',
    addToken,
    data,
  });
}